import { FormattedMessage } from 'react-intl';
import { Tabs, TabsContent, TabsList, TabsTrigger } from 'src/registry/ui/Tabs';
import { financialDocumentsMessages } from 'src/features/financialDocuments/utils/messages';
import FinancialDocumentsTable from 'src/features/financialDocuments/components/tables/FinancialDocumentsTable';
import useHasPermissions from 'src/utils/useHasPermissions';
import { PERMISSION } from 'src/features/auth/types';

const AccountingRangeDashboardTables = () => {
    const permissionAccessFinancialDocs = useHasPermissions([PERMISSION.ACCESS_FINANCIAL_DOCUMENTS]);

    if (!permissionAccessFinancialDocs) return null;
    return (
        <div className="grid flex-3 grid-cols-1 pr-8">
            <Tabs defaultValue="financial-documents">
                <TabsList>
                    <TabsTrigger value="financial-documents">
                        <FormattedMessage {...financialDocumentsMessages.financialDocuments} />
                    </TabsTrigger>
                </TabsList>
                <TabsContent value="financial-documents">
                    <FinancialDocumentsTable />
                </TabsContent>
            </Tabs>
        </div>
    );
};

export default AccountingRangeDashboardTables;
